import  Parse from 'parse';
import {Observable} from "rxjs";
import {fromPromise} from "rxjs/internal-compatibility";
import {map, switchMap} from "rxjs/operators";
import {
    arrayIsSet,
    fetchObject$,
    objectIsSet,
    paramsParseQuery,
    stringIsSet
} from "../providers/service/global-variables.service";
import {ProgettiParse} from "./Progetti.Parse";
import {ElementParse} from "./Element.Parse";
import {GeoPoint} from "parse";
import {IoTDeviceConfigurationParse2} from "./IoTDeviceConfiguration.Parse";

export enum EdgeDeviceType {
    NONE = -1,
    KIT_HOME_BUDDY = 0,
    HOME_BUDDY_MINI_V0 = 1,
    PICO_BUDDY = 2,
    BIG_BUDDY = 3,
    PICO_BUDDY_CITYSENSE = 4
}

export class IotDevicesParse {
    static CLASS_NAME = 'IoTDevices';
    id: string | undefined;
    localId: string | undefined;
    private _location: GeoPoint | undefined;


    constructor(id: string | undefined = undefined) {
        if (stringIsSet(id)) {
            this.id = id;
        } else {
            const time = new Date().getTime()
            this.localId = time.toString(32) + Math.round(Math.random() * 100).toString(32);
        }
    }

    private _creation_date: Date | undefined;
    private _last_edit_date: Date | undefined;

    private _progetti: Array<ProgettiParse> | undefined;
    private _element: ElementParse | undefined;
    private _serial: string | undefined;
    /**
     * @deprecated use `type` instead
     */
    private _deviceType: string | undefined;
    private _type: EdgeDeviceType | undefined;
    private _online: boolean | undefined;
    private _lastComm: Date | undefined;
    private _vpn_address: string | undefined;
    private _bleId: string | undefined;
    private _environment: string | undefined;
    private _floor: number | undefined;
    private _configuration: IoTDeviceConfigurationParse2 | undefined;


    public get objectId(): string {
        if (stringIsSet(this.id)) {
            return this.id;
        } else if (stringIsSet(this.seriale)) {
            return this.seriale;
        } else {
            return this.localId as string;
        }
    }

    public set objectId(value) {
        this.id = value;
    }

    public get creation_date(): Date | undefined {
        return this._creation_date
    }

    public set creation_date(value) {
        this._creation_date = value;
    }

    public get bleId(): string | undefined {
        return this._bleId
    }

    public set bleId(value) {
        this._bleId = value;
    }

    public get configuration(): IoTDeviceConfigurationParse2 | undefined {
        return this._configuration
    }

    public set configuration(value) {
        this._configuration = value;
    }

    public get deviceType(): string | undefined {
        return this._deviceType
    }

    public set deviceType(value) {
        this._deviceType = value;
    }

    public get environment(): string | undefined {
        return this._environment
    }

    public set environment(value) {
        this._environment = value;
    }

    public get floor(): number | undefined {
        return this._floor
    }

    public set floor(value) {
        this._floor = value;
    }

    public get element(): ElementParse | undefined {
        return this._element
    }

    public set element(value) {
        this._element = value;
    }

    public get last_edit_date(): Date | undefined {
        return this._last_edit_date
    }

    public set last_edit_date(value) {
        this._last_edit_date = value;
    }

    public get lastComm(): Date | undefined {
        return this._lastComm
    }

    public set lastComm(value) {
        this._lastComm = value;
    }

    public get location(): GeoPoint | undefined {
        return this._location
    }

    public set location(value) {
        this._location = value;
    }

    public get online(): boolean | undefined {
        return this._online
    }

    public set online(value) {
        this._online = value;
    }

    public get progetti(): ProgettiParse[] | undefined {
        return this._progetti
    }

    public set progetti(value) {
        this._progetti = value;
    }

    public get seriale(): string | undefined {
        return this._serial
    }

    public set seriale(value) {
        this._serial = value;
    }

    public get type(): EdgeDeviceType | undefined {
        return this._type
    }

    public set type(value) {
        this._type = value;
    }

    public get vpn_address(): string | undefined {
        return this._vpn_address
    }

    public set vpn_address(value) {
        this._vpn_address = value;
    }

    fromJson(json: any) {
        if (json != null) {
            if (stringIsSet(json.objectId)) {
                this.objectId = json.objectId
            } else if (stringIsSet(json.id)) {
                this.objectId = json.id;
            }
            if (arrayIsSet(json.progetti)) {
                this.progetti = json.progetti.map((p: any) => {
                    const house = new ProgettiParse();
                    house.objectId = p.objectId;
                    return house
                })
            }

            if (json.element != null) {
                const el = new ElementParse().fromJson(json.element);
                this.element = el;
            }
            if (stringIsSet(json.serial)) {
                this.seriale = json.serial;
            }if (stringIsSet(json.environment)) {
                this.environment = json.environment;
            }
            if (objectIsSet(json.configuration)) {
                this.configuration = new IoTDeviceConfigurationParse2(undefined).fromJson(json.configuration);
            }
            const specialKeys = ['objectId', 'id', 'configuration', 'element', 'progetti', 'serial']
            Object.keys(json)
                .forEach(key => {
                    if (!specialKeys.includes(key)) {
                        (this as any) [key] = json[key];
                    }
                })
        }
        return this;
    }

    addEdgeDeviceToProject$(projectId: string, seriale: string | undefined = undefined): Observable<IotDevicesParse> {
        if (stringIsSet(seriale)) {
            this.seriale = seriale;
        }
        const requestParams: Record<string, any> = paramsParseQuery({houseId: projectId, seriale: this.seriale})
        return fromPromise(Parse.Cloud.run('addEdgeDeviceToProject', requestParams)).pipe(
            map((dviceJson) => this.fromJson(dviceJson))
        )
    }

    removeEdgeDeviceFromProject$(projectId: string): Observable<IotDevicesParse> {
        const requestParams: Record<string, any> = paramsParseQuery({houseId: projectId, seriale: this.seriale})
        return fromPromise(Parse.Cloud.run('removeEdgeDeviceFromProject', requestParams))
    }

    setEdgeDeviceType$(newType: EdgeDeviceType | undefined, newLocation: GeoPoint | undefined = undefined, newEnvironment: string | undefined, unsetKeys: string[] = []): Observable<IotDevicesParse> {
        const type = newType != null ? newType : this.type
        let environment;
        if (unsetKeys.includes('environment')) {
            environment = null
        } else if (stringIsSet(newEnvironment)) {
            environment = newEnvironment
        } else {
            environment = this.environment
        }
        let location;
        if (unsetKeys.includes('location')) {
            location = null
        }
        if (newLocation != null) {
            location = {latitude: newLocation.latitude, longitude: newLocation.longitude}
        } else if (this.location) {
            location = {latitude: this.location?.latitude, longitude: this.location?.longitude}
        }
        const objParams: any = {seriale: this.seriale, type: type, location: location, environment: environment}
        const requestParams = paramsParseQuery(objParams)
        return fromPromise(Parse.Cloud.run('setEdgeDeviceInfo', requestParams)).pipe(
            switchMap(device => fetchObject$({
                objectId: device.objectId,
                className: IotDevicesParse.CLASS_NAME
            } as any)),
            map((dviceJson) => {
                let valueJSON
                if (dviceJson.toJSON) {
                    valueJSON = dviceJson.toJSON()
                } else if (dviceJson.attributes) {
                    valueJSON = dviceJson.attributes
                } else {
                    valueJSON = dviceJson
                }
                console.log(valueJSON)
                console.log(this.fromJson(valueJSON))
                return this.fromJson(valueJSON)
            })
        )
    }

    unset(key: string) {
        if (key in this) {
            (this as any)[key] = undefined
        }
    }


}

//
// export class IotDevicesParse extends Parse.Object {
//     public static CLASS_NAME = 'IoTDevices';
//
//     constructor() {
//         super(IotDevicesParse.CLASS_NAME);
//     }
//
//     public set objectId(value) {
//         this.id = value;
//     }
//
//     public get objectId() {
//         return this.id;
//     }
//
//     public set ACL(value) {
//         super.set('ACL', value);
//     }
//
//     public get ACL() {
//         return super.get('ACL');
//     }
//
//     public set createdAt(value) {
//         super.set('createdAt', value);
//     }
//
//     public get createdAt() {
//         return super.get('createdAt');
//     }
//
//     public set updatedAt(value) {
//         super.set('updatedAt', value);
//     }
//
//     public get updatedAt() {
//         return super.get('updatedAt');
//     }
//
//     public set building(value) {
//         super.set('building', value);
//     }
//
//     public get building() {
//         return super.get('building');
//     }
//
//     public set deviceType(value) {
//         super.set('deviceType', value);
//     }
//
//     public get deviceType() {
//         return super.get('deviceType');
//     }
//
//     public set element(value) {
//         super.set('element', value);
//     }
//
//     public get element() {
//         return super.get('element');
//     }
//
//     public set progetto(value) {
//         super.set('progetto', value);
//     }
//
//     public get progetto() {
//         return super.get('progetto');
//     }
//
//     public set seriale(value) {
//         super.set('seriale', value);
//     }
//
//     public get seriale() {
//         return super.get('seriale');
//     }
//
//     public query(): Parse.Query<IotDevicesParse> {
//         return new Parse.Query(IotDevicesParse)
//     }
//
//     save$(): Observable<IotDevicesParse> {
//         return fromPromise(Parse.Object.saveAll([this])).pipe(
//             map((p) => (p as IotDevicesParse[])[0])
//         )
//     }
// }

// Parse.Object.registerSubclass(IotDevicesParse.CLASS_NAME, IotDevicesParse);
